import { Injectable } from '@angular/core'
import { CourseReferenceType } from '../enums/enrollment/course-reference-type.enum';
import { ApiClientService } from 'src/app/@core/services/api-client.service';
import { Status } from 'src/app/@core/enums/status.enum';
import { ApplicationRoutes } from 'src/app/@core/routes/application-routes.const';
import { StudentEnrollmentType } from '../enums/enrollment/student-enrollment-type.enum';

@Injectable({
    providedIn: 'root'
})

export class StudentEnrollmentService {

    constructor(private apiService: ApiClientService) { }

    getPending(referenceType: CourseReferenceType) {
        return this.apiService.get(`${ApplicationRoutes.Enrollment.PendingCoursesByReferenceTypePerTrainee(CourseReferenceType[referenceType])}`);
    }

    join(referenceType: CourseReferenceType, referenceId: number) {
        return this.apiService.create(`${ApplicationRoutes.Enrollment.JoinTrainee(CourseReferenceType[referenceType], referenceId)}`, null);
    }

    // Student approvement on nominated courses
    studentApprovement(referenceType: CourseReferenceType, referenceId: number, approved: boolean) {
        return this.apiService.update(ApplicationRoutes.Enrollment.NominationApprovement(CourseReferenceType[referenceType], referenceId, approved), null);
    }

    assign(referenceType: CourseReferenceType,
        id: number, studentsIds: number[], enrollmentType: StudentEnrollmentType) {
        return this.apiService
            .create(ApplicationRoutes.Enrollment.AssignTrainee(referenceType, id), { studentsIds, enrollmentType });
    }
}
